(function () {
  class Freespins {
    constructor() {
      var self = this;
      this._startHolder = undefined;
      this._endHolder = undefined;
      this.fsCountText = undefined;
      this.fsCountTextMobile = undefined;
      this._fsWinningsMeter = undefined;
      this._fsWinningsMeterMobile = undefined;
      this._fsActive = false;
      this._freespinsCount = 0;
      this.fsPulseCount = 0;
      this.fsPulseNumSpins = 0;
      this.retrigAward = 0;
      this.inRetrigger = false;
      this._spinsLeft = 0;
      this.moonCount = 0;
      this.retrigCB = undefined;
      this._outroPopup = undefined;
      this._winningsThisSpin = 0;
      this.powerPackCount = 0;
      this._inFSCashLink = false;
      this._bonusSymbolPos = undefined;
      this._freespinsTune = undefined;
      this.continueUp = undefined;
      this.continueDown = undefined;
      this.hasLoaded = false;
      this._doSpinFunc = this.doSpin.bind(this);
      this._doSpinDeadFunc = this.doSpinDead.bind(this);
      this._onCashLinkStartEventFunc = this.onCashLinkStartEvent.bind(this);
      this._onCashLinkEndEventFunc = this.cashLinkEndEvent.bind(this);
      this.freespinsEndStake = undefined;

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsStartEvent",
        this.onFreespinsStart.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsStartEventDead",
        this.onFreespinsStartDead.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsDataEvent",
        this.onFreespinsData.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsDataEventDead",
        this.onFreespinsDataDeadEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsRetriggerEvent",
        this.onFreeSpinsRetriggerEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsEndEvent",
        this.onFreespinsEndEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:WinningLinesEvent",
        this.doPayWins.bind(this)
      );
      this._payWinsDeadFunc = this.doPayWinsDead.bind(this);
      messageBus.subscribe(
        "bountyhunter:skipWins",
        this.skipAnimations.bind(this)
      );
      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
      Reflex.registerEventHandler(
        "layoutChange",
        this.onLayoutChange.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsAwardEventDead",
        this.onFreespinsAwardedEnd.bind(this)
      );

      messageBus.subscribe(
        "spinner:FSMultiplier",
        this.ProcessFSMultiplier.bind(this)
      );

      StateMachine.Create(this);
      Reflex.addToUpdate(function (delta, time) {
        self.update(delta, time);
      });

      this.stateMachine.addState("IDLE", function () {});
      this.stateMachine.addState("OUTRO", function () {
        self.update_outroState();
      });
      this.stateMachine.addState("OUTRO_POPUP", function () {
        self.update_outroPopupState();
      });

      this.stateMachine.addState("PREBIGWIN", function () {
        self.update_preBigWinState();
      });

      this.continueUp = undefined;
      this.continueDown = undefined;
    }

    update(delta, time) {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }

    skipAnimations() {}

    onLayoutChange() {
      if (this._fsActive) {
        this.onOrientationChange();
      }
    }

    hideAllAnimations() {}

    onFreespinsStart(task) {
      this._startHolder = task;
      this._startHolder.join();

      this.fsPulseCount = 0;
      this.moonCount = 0;
      this.powerPackCount = 0;
      gameController.messageBox.onSpinEnd();

      this.start(task);
    }

    start(task) {
      this._potContainer = resourceManager.get("potsContainer");
      resourceManager.get("slotContainer:multiplierContainer").visible = true;
      resourceManager.getContainer("freespinsContainer").visible = true;
      gameController.valuesSpin.removeAllChildren();
      // gameController.topValueOverlays.removeAllChildren();
      gameController.slotMachine.clearDimSymbolIds();

      resourceManager.getController("inputOverlord").setState("freespins");
      messageBus.subscribe("spinner:SpinEvent", this._doSpinFunc);
      messageBus.subscribe("spinner:SpinEventDead", this._doSpinDeadFunc);
      messageBus.subscribe(
        "spinner:WinningLinesEventDead",
        this._payWinsDeadFunc
      );
      messageBus.subscribe(
        "powerPack:cashLinkStartEvent",
        this._onCashLinkStartEventFunc
      );
      messageBus.subscribe(
        "powerPack:cashLinkEndEventDead",
        this._onCashLinkEndEventFunc
      );

      this._fsWinningsMeter.set(0);
      this._fsWinningsMeterMobile.set(0);

      gameController.slotMachine.selectReelMode("freespins");

      gameController.freespinsWinnings = 0;
      gameController.inFreeSpins = true;

      this._winnings = 0;
      this._freespinsCount = task.data.freeSpinsAwarded;
      this._spinsLeft = task.data.freeSpinsAwarded;
      gameController.freeSpinsLeft = this._spinsLeft;
      let bonusWin = 0;
      if (task.data.bonusWin) {
        bonusWin = task.data.bonusWin;
      }

      this.fsCountText.setTranslationParameters(
        this._freespinsCount - this._spinsLeft,
        0
      );

      this.fsCountTextMobile.setTranslationParameters(
        this._freespinsCount - this._spinsLeft,
        0
      );

      if (layoutController.getCurrentLayout() === "landscape_mobile") {
        this.fsCountTextMobile.visible = true;
      } else {
        this.fsCountText.visible = true;
      }

      this.currentMultiplierValue = 1;

      gameController.multiplier = 1;

      this.multiplierValue.setText(`X${this.currentMultiplierValue}`);

      this._fsActive = true;
      this.onOrientationChange();

      this._freespinElements.forEach(function (element) {
        element.visible = true;
        element.alpha = 0;
      });
      gameController.messageBox.showLogo(true);
      this._bg.visible = true;
      this._bg.alpha = 0;

      const self = this;
      timerManager.addTimer(
        800,
        function (progress) {
          self._freespinElements.forEach(function (element) {
            element.alpha = progress;
          });

          self._introPopup.alpha = progress;
          self._bg.alpha = progress;
        },
        function () {
          self._freespinElements.forEach(function (element) {
            element.alpha = 1;
          });
          self._logo.alpha = 1;
          self._logo.visible = false;

          self._bg.alpha = 1;
          timerManager.addTimeout(250, function () {
            self._winnings += gameController.totalWinBeforeFreeSpins;

            gameController.freespinsWinnings +=
              gameController.totalWinBeforeFreeSpins;

            self._fsWinningsMeter.set(
              gameController.totalWinBeforeFreeSpins + bonusWin
            );

            self._fsWinningsMeterMobile.set(
              gameController.totalWinBeforeFreeSpins + bonusWin
            );

            self.startPowerPackAnimation();
          });
        }
      );
    }

    startPowerPackAnimation(cb) {
      gameController.countingMoons = true;
      if (this.inRetrigger) {
        this.retrigCB = cb;
      }
      if (
        this.powerPackCount < gameController.powerPacksLanded.length &&
        !gameController.winSkipped
      ) {
        this.moonCount = 0;
        this.startMoonPulse(0);
      } else {
        gameController.winSkipped = false;
        gameController.countingMoons = false;
        this.moonCount = 0;
        this.powerPackCount = 0;
        this.playAllMoons();
        this.updateCountText();
        this.fsPulseCount = this._freespinsCount + this.retrigAward;
        for (let i = 0; i < gameController.powerPacksLanded.length; i++) {
          let ppSymbolData = gameController.powerPacksLanded[i];
          gameController.animateOversized(
            [ppSymbolData],
            ppSymbolData.oversizedSymbolID
          );
          if (ppSymbolData.hasValue) {
            ppSymbolData.symbolId =
              gameData.symbols["Symbol_Power_Pack_Total"].ID;
            let reelPP = {
              cell: {
                reel: ppSymbolData.cell.reel,
                row: ppSymbolData.cell.row,
              },
              symbolId: gameData.symbols["Symbol_Power_Pack"].ID,
            };

            gameController.hideOversized(reelPP, 19); //hide reel powerpack
          }
        }
      }
    }

    playAllMoons(cb) {
      const self = this;

      gameController.moonValues.forEach(function (moon) {
        let symbolData = {
          cell: { reel: moon.reel, row: moon.row },
          symbolId: gameData.symbols["Symbol_Moon_Active"].ID,
        };
        let slotCell = moon.reel * gameData.numRows + moon.row;

        gameController.valuesMoons.playMoonMovie(slotCell, false);

        gameController.bonusLandAnimator.animateSymbols(
          [symbolData],
          gameController.slotMachine,
          true,
          false,
          function () {
            gameController.showMoonOversized(gameController.moonValues);
            if (self.inRetrigger) {
              self.retrigCB();
            } else {
              self._introPopup.alpha = 1;
              gameData.musicManager.onFreeSpinsIntro();
              self._introPopup.showIntro(
                self._freespinsCount,
                self.introComplete.bind(self)
              );
            }
          },
          undefined,
          undefined,
          undefined,
          true
        );
      });
    }

    startMoonPulse(numOfSpins) {
      if (
        this.moonCount < gameController.moonValues.length &&
        !gameController.winSkipped
      ) {
        const moon = gameController.moonValues[this.moonCount];
        let fsPulseNumSpins =
          gameController.moonValues[this.moonCount].numberOfSpins;

        if (numOfSpins < fsPulseNumSpins) {
          let symbolData = {
            cell: { reel: moon.reel, row: moon.row },
            symbolId: gameData.symbols["Symbol_Moon_Active"].ID,
          };
          if (!gameController.winSkipped) {
            this.animatePulse(symbolData, numOfSpins, moon.slotCell);

            this.fsPulseCount++;

            this.fsCountText.setTranslationParameters(
              this._freespinsCount - this._spinsLeft,
              this.fsPulseCount
            );
            this.fsCountTextMobile.setTranslationParameters(
              this._freespinsCount - this._spinsLeft,
              this.fsPulseCount
            );
          } else {
            this.updateCountText();
          }
        } else {
          this.moonCount++;
          this.startMoonPulse(0);
        }
      } else {
        this.powerPackCount++;
        this.startPowerPackAnimation(this.retrigCB);
      }
    }

    animatePulse(symbolData, numOfSpins, slotCell) {
      soundManager.play("scatterWin");

      const self = this;
      gameController.valuesMoons.playMoonMovie(slotCell, false);

      let ppSymbolData = gameController.powerPacksLanded[this.powerPackCount];

      gameController.powerPackDisplay.showPowerPackOverlay(
        ppSymbolData.cell.reel * gameData.numRows + ppSymbolData.cell.row,
        false
      );

      let reelPP = {
        cell: { reel: ppSymbolData.cell.reel, row: ppSymbolData.cell.row },
        symbolId: gameData.symbols["Symbol_Power_Pack"].ID,
      };

      gameController.hideOversized(reelPP); //hide reel powerpack

      if (ppSymbolData.hasValue) {
        ppSymbolData.symbolId = gameData.symbols["Symbol_Power_Pack_Total"].ID;
      } else {
        ppSymbolData.symbolId = gameData.symbols["Symbol_Power_Pack"].ID;
        gameController.hideOversized(ppSymbolData);
      }

      gameController.bonusLandAnimator.animateSymbols(
        [ppSymbolData],
        gameController.slotMachine,
        true,
        false,
        function () {},
        undefined,
        undefined,
        undefined,
        true
      );

      gameController.bonusLandAnimator.animateSymbols(
        [symbolData],
        gameController.slotMachine,
        true,
        false,
        function () {
          if (ppSymbolData.hasValue) {
            gameController.powerPackDisplay.showPowerPackOverlay(
              ppSymbolData.cell.reel * gameData.numRows + ppSymbolData.cell.row,
              true
            );
          } else {
            gameController.bonusLandAnimator.animateSymbols(
              [ppSymbolData],
              gameController.slotMachine,
              true,
              false,
              function () {},
              undefined,
              undefined,
              undefined,
              true
            );
          }
          gsap.fromTo(
            [self.fsCountText],
            { pixi: { scaleX: 1, scaleY: 1 } },
            {
              pixi: { scaleX: 1.3, scaleY: 1.3 },
              duration: 0.1,
              yoyo: true,
              repeat: 1,
              onStart: () => {
                gameController.valuesMoons.playMoonMovie(slotCell, true);
                numOfSpins++;
                self.startMoonPulse(numOfSpins);
              },
              onComplete: () => {},
            }
          );
        },
        undefined,
        undefined,
        undefined,
        true
      );
    }

    onOrientationChange() {
      if (this._fsActive && this.hasLoaded) {
        switch (layoutController.getCurrentLayout()) {
          case "landscape_default":
          case "landscape_mobile": {
            this._logo = resourceManager.get("logo");
            this._bg = resourceManager.get(
              "landscapeBackground:freespinsBackground"
            );
            break;
          }

          case "portrait_default":
          case "portrait_mobile":
          default: {
            this._logo = resourceManager.get("logoPortrait");
            this._bg = resourceManager.get(
              "portraitBackground:freespinsBackground"
            );
            break;
          }
        }
        this._bg.alpha = 1;
        this._logo.visible = false;
      }
    }

    introComplete() {
      this._startHolder.leave();
    }

    onFreespinsStartDead() {
      const self = this;
      if (gameController.wasInCoinAwardsMod || gameController.wasCashLink) {
        gameController.wasInCoinAwardsMod = false;
        gameController.wasCashLink = false;
        gameController.powerPackDisplay.reset();
      }

      self.getNextSpinOutcome();
    }

    getNextSpinOutcome() {
      if (gameController.wasInCoinAwardsMod || gameController.wasCashLink) {
        gameController.wasInCoinAwardsMod = false;
        gameController.wasCashLink = false;
        gameController.powerPackDisplay.reset();
      }
      gameController.messageBox.showLogo(true);
      gameController.setSpinMoonValues();
      gameController.dimOversized(gameController.overSizedSymbols, false, 0.1); //reset oversized symbols dim
      gameController.hideAllOversized();
      gameController.topValueOverlays.clearAllCoinAndPotValues();
      gameController.powerPacksLanded = [];
      gameController.winningOversizedSymbols = [];
      gameController.nonWinningOversizedSymbols = [];
      gameController.inCoinAwardsModifier = false;
      gameController.inCashLinkAwardDisplay = false;
      gameController.nonWinnin;
      gameController.initNewSpin();

      this._spinsLeft--;
      gameController.freeSpinsLeft = this._spinsLeft;
      this.updateCountText();
      gameController.overSizedInProcess = true;
      gdk.getNextGameOutcome(function () {});
    }

    updateCountText() {
      if (this._fsActive) {
        if (this.inRetrigger) {
          this.fsCountText.setTranslationParameters(
            this._freespinsCount - this._spinsLeft,
            this._freespinsCount + this.retrigAward
          );
          this.fsCountTextMobile.setTranslationParameters(
            this._freespinsCount - this._spinsLeft,
            this._freespinsCount + this.retrigAward
          );
        } else {
          this.fsCountText.setTranslationParameters(
            this._freespinsCount - this._spinsLeft,
            this._freespinsCount
          );
          this.fsCountTextMobile.setTranslationParameters(
            this._freespinsCount - this._spinsLeft,
            this._freespinsCount
          );
        }

        if (layoutController.getCurrentLayout() === "landscape_mobile") {
          this.fsCountTextMobile.visible = true;
        } else {
          this.fsCountText.visible = true;
        }
      }
    }

    doSpin(spinTask) {
      gameController.stopSymbolFrameDisplay();
      // Hide Moons
      gameController.clearMoonValues();
      //KEEPING THESE FOR A BIT
      //gameController.hideAllOversized();
      // if (spinTask.data.isWolfRun) {
      //   gameController.valueOverlays.clearAllSpinMoonValues();
      //   gameController.valueOverlays.clearAllSpinCoinValues();
      // }
      gameController.overSizedSymbols = [];
      gameController.reelStopping = [false, false, false, false, false, false];
      //Hide Coins
      //KEEPING THESE FOR A BIT
      //gameController.clearCoinValues();

      if (spinTask.data.coins) {
        gameController.setCoinValues(spinTask);
      }

      this._winningsThisSpin = 0;

      this._bonusSymbolPos = undefined;
      for (
        let reel = 0;
        reel < spinTask.data.resultPanel.reelList.length;
        ++reel
      ) {
        for (
          let row = 0;
          row < spinTask.data.resultPanel.reelList[reel].symbols.length;
          ++row
        ) {
          if (
            spinTask.data.resultPanel.reelList[reel].symbols[row].value ===
            gameData.symbols["Symbol_Moon"].ID
          ) {
            this._bonusSymbolPos = { reel, row };
            break;
          }
        }
        if (this._bonusSymbolPos) {
          break;
        }
      }
    }

    doPayWins(task) {
      if (gameController.inFreeSpins) {
        this._winningsThisSpin =
          task.data.totalLineWinnings + task.data.coinWinnings;

        if (this._winningsThisSpin > 0) {
          gameData.musicManager.increaseLevel("freeSpins");
        }
      }
    }

    update_outroPopupState() {
      if (this.phase.enter()) {
        gameController.stopSymbolFrameDisplay();

        gsap.fromTo(
          [this.popupMaskDimObject, this._outroPopup],
          {
            alpha: 0,
          },
          {
            alpha: 1,
            duration: 0.5,
            onStart: () => {
              gameData.musicManager.onFreeSpinsOutro();
              this._outroPopup.visible = true;
              this.popupMaskDimObject.visible = true;
            },
            onComplete: () => {},
          }
        );
      }

      if (this.phase.once()) {
        this._outroPopup.alpha = 1;
        this.continueUp.interactive = true;
        const self = this;
        this.continueUp.touchend = this.continueUp.mousedown = function () {
          self.continueUp.interactive = false;
          self.continueUp.visible = false;
          self.continueDown.visible = true;
          timerManager.addTimer(
            250,
            function () {},
            function () {
              //TODO: HB: Animate the frame disappearing
              self.continueUp.visible = true;
              self.continueDown.visible = false;
              self._outroPopup.alpha = 0;
              self.stateMachine.switchState("PREBIGWIN");
            }
          );
        };
      }
    }

    update_outroState() {
      if (this.phase.enter()) {
        this._logo.alpha = 0;

        switch (layoutController.getCurrentLayout()) {
          case "landscape_default":
          case "landscape_mobile": {
            this._logo.visible = true;
            break;
          }
        }

        this._outroPopup.alpha = 1;
        this._outroPopup.visible = false;

        gameController.freespinsWinnings =
          this._winnings - gameController.reelsPrize;
        gameData.winningsMeter.set(this._winnings);
        gameData.winningsMeterMobile.set(this._winnings);

        gsap.to(this._logo, {
          alpha: 1,
          duration: 0.5,
          delay: 0.5,
        });
      }

      if (this.phase.timed(500)) {
        const progress = this.phase.Progress;
        this._freespinElements.forEach(function (element) {
          element.alpha = 1 - progress;
        });
        this._bg.alpha = 1 - progress;
      }

      if (this.phase.once()) {
        this._bg.alpha = 1;
        this._bg.visible = false;

        resourceManager.get(
          "slotContainer:multiplierContainer"
        ).visible = false;
        resourceManager.getContainer("freespinsContainer").visible = false;

        this.stateMachine.switchState("IDLE");
      }

      if (this.phase.exit()) {
        gameController.onStakeChanged(
          resourceManager
            .getController("stakeController")
            .getCurrentStake("default"),
          false
        );

        this._endHolder.leave();
        this._fsActive = false;
        this.fsCountText.visible = false;
        this.fsCountTextMobile.visible = false;
        resourceManager.getController("inputOverlord").setState("enabled");
        gameController.freespinsComplete(this._endHolder.data.fsWinnings);
      }
    }

    onGameConfigEvent() {
      this._logo = undefined;
      this._bg = undefined;

      switch (layoutController.getCurrentLayout()) {
        case "landscape_default":
        case "landscape_mobile": {
          this._logo = resourceManager.get("logo");
          this._bg = resourceManager.get(
            "landscapeBackground:freespinsBackground"
          );
          break;
        }

        case "portrait_default":
        case "portrait_mobile":
        default: {
          this._logo = resourceManager.get("logoPortrait");
          this._bg = resourceManager.get(
            "portraitBackground:freespinsBackground"
          );
          break;
        }
      }

      this._bg.visible = false;

      resourceManager.getContainer("freespinsContainer").visible = true;

      this._freespinElements = [
        resourceManager.getContainer("freespinsContainer"),
        resourceManager.get("slotContainer:multiplierContainer"),
        resourceManager.get("totalWinningsContainer"),
        resourceManager.get("freespinsCountContainer"),
      ];
      this._freespinElements.forEach(function (element) {
        element.visible = false;
      });

      this._retriggerPopUp = resourceManager.get(
        "featurePopupContainer:freespinsRetriggerPopup"
      );

      this._showIndividualWinsInFreespins = gdk.mustShowSlowWin();

      this._fsWinningsMeter = resourceManager.get(
        "totalWinningsContainer:winningsMeter"
      );

      this._fsWinningsMeterMobile = resourceManager.get(
        "totalWinningsContainer:winningsMeterMobile"
      );

      this.multiplierValue = resourceManager.get(
        "slotContainer:multiplierContainer:multiplierValue"
      );

      this._pot = resourceManager.get(
        "slotContainer:multiplierContainer:multiplierPanel"
      );

      this.fsCountText = resourceManager.get(
        "freespinsCountContainer:freespinsCount"
      );

      this.fsCountTextMobile = resourceManager.get(
        "freespinsCountContainer:freespinsCountMobile"
      );

      this._introPopup = resourceManager.get(
        "featurePopupContainer:freespinsIntroPopup"
      );
      this._introPopup.visible = false;

      this._outroPopupWin = resourceManager.get(
        "featurePopupContainer:freespinsOutroWinPopup"
      );
      this._outroPopupWin.visible = false;
      this._outroPopupWinButton = resourceManager.get(
        "featurePopupContainer:freespinsOutroWinPopup:moon:continueButton"
      );
      this._outroPopupWinValue = resourceManager.get(
        "featurePopupContainer:freespinsOutroWinPopup:moon:win"
      );

      this._fsCountWinner = resourceManager.get("fsCount");
      this._fsCountWinner.visible = false;
      this._fsTitleWinner = resourceManager.get("fsTitle");
      this._fsTitleWinner.visible = false;

      this.popupMaskDimObject = resourceManager.get(
        "featurePopupContainer:darkBackground"
      );

      this.continueUp = resourceManager.get(
        "featurePopupContainer:freespinsOutroWinPopup:moon:continueButton:continueUp"
      );

      this.continueDown = resourceManager.get(
        "featurePopupContainer:freespinsOutroWinPopup:moon:continueButton:continueDown"
      );
      this.continueDown.visible = false;

      this.continueUp.interactive = false;

      this.hasLoaded = true;
    }

    doSpinDead(spinTask) {
      if (spinTask.powerPacks.length > 0 && spinTask.totalWinnings === 0) {
        gameController.multiplier = spinTask.newMultiplier;
        this.increaseMultiplier(spinTask.newMultiplier);
      }
    }

    onCashLinkStartEvent() {
      this._inFSCashLink = true;
    }

    cashLinkEndEvent(task) {
      this._winnings += task.winAmount;
      this._winningsThisSpin += task.winAmount;
      this._fsWinningsMeter.set(this._winnings);
      this._fsWinningsMeterMobile.set(this._winnings);
      this._inFSCashLink = false;
    }

    sortOutLayout() {
      switch (layoutController.getCurrentLayout()) {
        case "landscape_default": {
          resourceManager.get("freespinsTimeBackground").visible = true;
          resourceManager.get("freespinsStake").visible = true;
          resourceManager.get("freespinsCredit").visible = true;
          break;
        }
        case "portrait_default":
        case "portrait_mobile": {
          resourceManager
            .get("slotContainer")
            .position.setY(
              layoutController.getCurrentPosition("slotContainer").y - 150
            );
          resourceManager.get("freespinsTimeBackground").visible = false;
          resourceManager.get("freespinsStake").visible = false;
          resourceManager.get("freespinsCredit").visible = false;
          break;
        }

        case "landscape_mobile": {
          resourceManager
            .get("slotContainer")
            .position.setX(
              layoutController.getCurrentPosition("slotContainer").x + 50
            );
          resourceManager.get("freespinsTimeBackground").visible = false;
          resourceManager.get("freespinsStake").visible = false;
          resourceManager.get("freespinsCredit").visible = false;
          break;
        }
      }
    }

    onFreeSpinsRetriggerEvent(task) {
      const self = this;
      task.join();
      this.retrigAward = task.data.extraSpinsAdded;
      this.inRetrigger = true;
      this.startPowerPackAnimation(function () {
        this.inRetrigger = false;
        this.retrigCB = undefined;

        self.showFreespinsPopup(this.retrigAward, task);
      });
    }

    showFreespinsPopup(award, task) {
      const self = this;
      this._retriggerPopUp.show(award, function () {
        self._spinsLeft += award;
        gameController.freeSpinsLeft = self._spinsLeft;
        self._freespinsCount += award;
        self.updateCountText();
        task.leave();
      });
    }

    increaseMultiplier(award, callback) {
      const start = this.currentMultiplierValue;
      const end = award;
      const self = this;
      gameController.multiplier = award;

      this.showMultiplierIncrease(end - this.currentMultiplierValue, 1200);

      timerManager.addTimer(
        800,
        function (progress) {
          const val = Math.floor(start + (end - start) * progress);
          self.multiplierValue.setText(`X${val}`);
        },
        function () {
          self.multiplierValue.setText(`X${end}`);
          self.currentMultiplierValue = end;
        }
      );
    }

    showMultiplierIncrease(amount, duration) {
      gameController.stopSymbolFrameDisplay();

      const self = this;

      gsap.timeline().to(
        self.multiplierValue,
        {
          duration: 0.2,
        },
        "<"
      );

      if (amount > 0) {
        gsap.fromTo(
          self.multiplierValue,
          { pixi: { scale: 1 } },
          {
            pixi: { scale: 1.25 },
            duration: 0.5,
            yoyo: true,
            repeat: 1,
          }
        );
      }
    }

    onFreespinsAwardedEnd() {}

    onFreespinsData(task) {}

    onFreespinsDataDeadEvent(task) {
      gameController.isInWolfRun = false;
      const self = this;
      if (!this._inFSCashLink) {
        if (this._winningsThisSpin > 0) {
          timerManager.addTimer(500, undefined, function () {
            self.getNextSpinOutcome();
          });
        } else {
          gameController.messageBox.showLogo(true);
          timerManager.addTimer(500, undefined, function () {
            if (task.isWolfRun) {
              gameController.wildWolfRun.resetWildWolfRun();
            }
            self.getNextSpinOutcome();
          });
        }
      }
    }

    getFreespinsEndStake() {
      let cost;

      if (gameController.inBuyABonus) {
        let mode = "FREESPINS_BUY";
        let stake = resourceManager
          .getController("stakeController")
          .getCurrentStake(mode);
        let buyCost = buyBonusPopup.gameConfig.data.buyBonusCostFreeSpins / 10;
        cost = stake * buyCost;
      } else {
        cost = resourceManager
          .getController("stakeController")
          .getCurrentStake();
      }
      return cost;
    }

    onFreespinsEndEvent(task) {
      this.freespinsEndStake = this.getFreespinsEndStake();

      this._endHolder = task;
      this._endHolder.join();

      gameController.slotMachine.clearDimSymbolIds();

      messageBus.unsubscribe("spinner:SpinEvent", this._doSpinFunc);
      messageBus.unsubscribe("spinner:WinningLinesEvent", this.doPayWins);
      messageBus.unsubscribe(
        "spinner:WinningLinesEventDead",
        this._payWinsDeadFunc
      );
      messageBus.unsubscribe("spinner:SpinEventDead", this._doSpinDeadFunc);
      messageBus.unsubscribe(
        "powerPack:cashLinkStartEvent",
        this._onCashLinkStartEventFunc
      );
      messageBus.unsubscribe(
        "powerPack:cashLinkEndEventDead",
        this._onCashLinkEndEventFunc
      );

      this._freespinsCount = 0;
      gameController.slotMachine.selectReelMode("default");

      this._outroPopupWinValue.setText(
        gdk.formatCurrency(task.data.fsWinnings)
      );
      this._outroPopup = this._outroPopupWin;
      this.stateMachine.switchState("OUTRO_POPUP");
    }

    update_preBigWinState() {
      if (this.phase.enter()) {
        this.popupMaskDimObject.alpha = 0;
        this.popupMaskDimObject.visible = false;
      }

      if (this.phase.hold()) {
        if (!soundManager.isSoundPlaying("eb_bonus_end_v1")) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        if (this._winnings > this.freespinsEndStake) {
          if (gameController.bigWin.checkBigWin(this._winnings)) {
            let isWincap = this._endHolder.data.isCapped;

            if (isWincap && !gameController.hasBeenWinCapped) {
              isWincap = true;
            } else {
              isWincap = false;
            }
            const self = this;
            gameController.bigWin.clearSkippedFlag();

            gameController.bigWin.start(
              this._winnings,
              function () {
                gameController.winningsContainer.visible = true;
                self.stateMachine.switchState("OUTRO");
              },
              false,
              false,
              function () {},
              false,
              isWincap
            );
          } else {
            this.stateMachine.switchState("OUTRO");
          }
        } else {
          this.stateMachine.switchState("OUTRO");
        }
      }
    }

    ProcessFSMultiplier(task) {
      this.increaseMultiplier(task.data.newMultiplier);
    }

    doPayWinsDead(task) {
      this._winnings += task.totalLineWinnings + task.coinWinnings;
      gameController.freespinsWinnings += task.totalLineWinnings;

      const total = this._winningsThisSpin;

      if (this._fsActive && total > 0) {
        this._fsWinningsMeter.set(this._winnings);
        this._fsWinningsMeterMobile.set(this._winnings);
      }
    }
  }

  new Freespins();
})();
